import React from 'react'
import { Wallet, CreditCard, TrendingUp, Shield, Smartphone, Users } from 'lucide-react'

const Services = () => {
  const services = [
    {
      icon: Wallet,
      title: 'Personal Banking',
      description: 'Checking and savings accounts with no monthly fees',
      features: ['Zero monthly charges', 'Free debit card', 'Mobile banking', 'Instant transfers']
    },
    {
      icon: CreditCard,
      title: 'Business Banking',
      description: 'Comprehensive solutions for your business needs',
      features: ['Business accounts', 'Merchant services', 'Payroll solutions', 'Business loans']
    },
    {
      icon: TrendingUp,
      title: 'Loans & Credit',
      description: 'Flexible loan options with competitive rates',
      features: ['Personal loans', 'Auto loans', 'Home loans', 'Quick approval']
    },
    {
      icon: Shield,
      title: 'Investment Services',
      description: 'Grow your wealth with expert guidance',
      features: ['Savings plans', 'Fixed deposits', 'Investment advice', 'Retirement planning']
    },
    {
      icon: Smartphone,
      title: 'Mobile Banking',
      description: 'Bank anytime, anywhere with our mobile app',
      features: ['iOS & Android', 'Biometric login', 'Bill payments', 'Account management']
    },
    {
      icon: Users,
      title: '24/7 Support',
      description: 'We are here whenever you need us',
      features: ['Live chat', 'Phone support', 'Email assistance', 'In-person appointments']
    }
  ]

  return (
    <div>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-blue-100 dark:from-dark-800 dark:to-dark-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Our Services
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Comprehensive banking solutions designed for your financial success
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="card hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center mb-4">
                <service.icon className="w-7 h-7 text-blue-600 dark:text-blue-400" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                {service.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-800 dark:to-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">
            Ready to Experience Better Banking?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Open your free account today and enjoy all our services with zero hidden fees.
          </p>
          <a
            href="/register"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-colors"
          >
            Get Started Now
          </a>
        </div>
      </section>
    </div>
  )
}

export default Services